import * as React from "react"
import { cn } from "@/lib/utils"

export interface ShoppingCartIconProps extends React.SVGProps<SVGSVGElement> {
  /**
   * Size of the icon in pixels
   * @default 18
   */
  size?: number
}

/**
 * Shopping Cart icon as SVG (cart with wheels)
 *
 * This icon represents the shopping cart / buy action in the ANYW3AR app.
 * Used in product cards for purchase CTAs.
 *
 * @example
 * ```tsx
 * <ShoppingCartIcon />
 * <ShoppingCartIcon size={16} className="text-gray-500" />
 * ```
 */
export const ShoppingCartIcon = React.forwardRef<SVGSVGElement, ShoppingCartIconProps>(
  ({ size = 18, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 12 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className={cn("inline-flex shrink-0", className)}
        aria-hidden="true"
        {...props}
      >
        <path d="M.2.6c0-.2,0-.3.2-.4.1-.1.3-.2.4-.2h1.6c.3,0,.5,0,.7.2.1.1.2.3.3.6v.4h7.7c.2,0,.4,0,.5.2.1.1.2.3.2.4s0,0,0,.1c0,0,0,0,0,.1l-.3,2.2c0,.4-.2.7-.4,1-.2.2-.5.3-.9.3H4v.5c0,0,.1.2.2.2,0,0,.1,0,.2,0h5.5c.1,0,.3,0,.4.1.1,0,.2.2.2.4s0,.3-.2.4c-.1,0-.2.1-.4.1h-5.7c-.4,0-.7-.1-.9-.3-.2-.2-.4-.5-.4-.9l-.7-4.9H.8c-.2,0-.3,0-.4-.2-.1-.1-.2-.3-.2-.4ZM3.7,9c0-.2,0-.3.1-.5,0-.1.2-.3.3-.3.1,0,.3-.1.5-.1.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3s-.3,0-.5-.1c-.1,0-.3-.2-.3-.3,0-.1-.1-.3-.1-.5ZM8.1,9c0-.2,0-.3.1-.5,0-.1.2-.3.3-.3.1,0,.3-.1.5-.1.3,0,.5,0,.7.3.2.2.3.4.3.7s0,.5-.3.7c-.2.2-.4.3-.7.3s-.5,0-.7-.3c-.2-.2-.3-.4-.3-.7Z" />
      </svg>
    )
  }
)

ShoppingCartIcon.displayName = "ShoppingCartIcon"
